// src/auth/AuthGuard.jsx
//
// Phase 2 Sprint 1: Route guard requiring authenticated user.
// Per P10: passes state.from for LoginPage redirect preservation.
// authguard-consent-gate slice: (A) a themed FullPageLoader while auth resolves
// (no blank screen); (B) a ConsentGate around the children -- a signed-in user
// with no valid consent record for the current required legal versions must
// accept before entering (fail-closed; catches accounts orphaned by the #17
// signup-consent bug). Neither touches the AuthProvider awaited sync barrier.

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth.js';
import FullPageLoader from './FullPageLoader.jsx';
import ConsentGate from '../components/ConsentGate.jsx';

export const AuthGuard = ({ children }) => {
    const { currentUser, loading } = useAuth();
    const location = useLocation();

    if (loading) return <FullPageLoader />; // Part A: on-brand loader, not a blank screen
    if (!currentUser) {
        // P10: preserve attempted destination for post-login redirect
        return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
    }
    // Part B: block entry until a valid consent record exists (fail-closed).
    return <ConsentGate uid={currentUser.uid}>{children}</ConsentGate>;
};
